export default {
  name: 'marking--printJasper',
  apiService: 'shoes',
  apiPath: '/admin/print/func/jasper',
  urlParamName: 'marking--printJasper',
};